import { createTheme } from "@material-ui/core/styles";
import CMS2 from "./CMS2";
//@ts-ignore
export default createTheme(CMS2);